// extracted by mini-css-extract-plugin
export var container = "_7m-0";
export var error = "_7m-9";
export var label = "_7m-5";
export var light = "_7m-6";
export var md = "_7m-3";
export var sm = "_7m-2";
export var thin = "_7m-8";
export var thinBold = "_7m-7";
export var vertical = "_7m-4";
export var xs = "_7m-1";